import useSWR from "swr";
import { get, map } from "lodash";
import Link from "next/link";
import {getAttachmentUrl} from "grandus-lib/utils/index";
import Newsletter from "components/forms/Newsletter";

import styles from "./Footer.module.scss";
import {useTranslation} from "next-i18next";
import Image from "next/image";

const Footer = ({isSrandon}) => {
  const { t } = useTranslation();

  const { data } = useSWR(
    "/api/pages/footer",
    (url) => fetch(url).then((r) => r.json()),
    {
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
    }
  );

  const webinstance = get(data, "webinstance", {});
  const statics = get(data, "statics", []);

  return (
    <footer id={styles.footer}>
      {!isSrandon ? (
        <div className={styles.newsletterFormHolder}>
          <div className="container">
            <div className={styles.newsletterFormWrapper}>
              <Newsletter/>
            </div>
          </div>
        </div>
      ) : ""}

      <div className={styles.socialBar}>
        <a href={get(webinstance, "globalSettings.facebook_link", "#")} title={`Facebook`} target={`_blank`}>
          <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M11.5644 22.9298H15.0765V14.1281H17.5296L17.7913 11.182H15.0826C15.0826 11.182 15.0826 10.0803 15.0826 9.50199C15.0826 8.80808 15.2226 8.53417 15.8922 8.53417C16.4339 8.53417 17.7913 8.53417 17.7913 8.53417V5.47852C17.7913 5.47852 15.7887 5.47852 15.3565 5.47852C12.7452 5.47852 11.5644 6.62895 11.5644 8.83243C11.5644 10.7498 11.5644 11.182 11.5644 11.182H9.73828V14.1646H11.5644V22.9298Z" fill="#43525A"/>
          </svg>
        </a>
        <a href={get(webinstance, "globalSettings.instagram_link", "#")} title={`Instagram`} target={`_blank`}>
          <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M14.0002 7.57136C16.0928 7.57136 16.3401 7.57739 17.1663 7.6196C17.9322 7.65579 18.3483 7.78243 18.6197 7.89099C18.9876 8.03573 19.2469 8.20459 19.5183 8.47597C19.7957 8.75339 19.9646 9.01271 20.1033 9.37456C20.2118 9.65197 20.3385 10.0681 20.3747 10.828C20.4109 11.6542 20.4229 11.9014 20.4229 13.9941C20.4229 16.0868 20.4169 16.3341 20.3747 17.1603C20.3385 17.9262 20.2118 18.3423 20.1033 18.6137C19.9586 18.9816 19.7897 19.2409 19.5183 19.5183C19.2469 19.7897 18.9816 19.9646 18.6197 20.1033C18.3423 20.2118 17.9262 20.3385 17.1663 20.3747C16.3401 20.4109 16.0928 20.4229 14.0002 20.4229C11.9075 20.4229 11.6602 20.4169 10.834 20.3747C10.0681 20.3385 9.65197 20.2118 9.38059 20.1033C9.01271 19.9586 8.75339 19.7897 8.47597 19.5183C8.20459 19.2409 8.02969 18.9816 7.89099 18.6137C7.78243 18.3363 7.65579 17.9202 7.6196 17.1603C7.58342 16.3461 7.57136 16.0928 7.57136 14.0002C7.57136 11.9075 7.57739 11.6602 7.6196 10.834C7.65579 10.0681 7.78243 9.65197 7.89099 9.38059C8.02969 9.01271 8.19856 8.74736 8.47597 8.47597C8.75339 8.19856 9.01271 8.02969 9.38059 7.89099C9.658 7.78243 10.0741 7.65579 10.834 7.6196C11.6602 7.58342 11.9075 7.57136 14.0002 7.57136ZM14.0002 6.16016C11.8713 6.16016 11.6059 6.17222 10.7677 6.2084C9.93542 6.24459 9.36249 6.37726 8.86194 6.57025C8.34329 6.76926 7.90908 7.04065 7.47486 7.47486C7.04065 7.90908 6.76926 8.34933 6.57025 8.86194C6.37726 9.36249 6.24459 9.92939 6.2084 10.7677C6.16619 11.6059 6.16016 11.8713 6.16016 14.0002C6.16016 16.129 6.16619 16.3944 6.2084 17.2326C6.24459 18.0649 6.37726 18.6378 6.57025 19.1384C6.76926 19.651 7.04065 20.0912 7.47486 20.5254C7.90908 20.9597 8.34933 21.231 8.86194 21.4301C9.36249 21.623 9.92939 21.7557 10.7677 21.7919C11.6059 21.8341 11.8713 21.8402 14.0002 21.8402C16.129 21.8402 16.3944 21.8341 17.2326 21.7919C18.0649 21.7557 18.6378 21.623 19.1384 21.4301C19.657 21.231 20.0912 20.9597 20.5254 20.5254C20.9597 20.0912 21.231 19.651 21.4301 19.1384C21.623 18.6378 21.7557 18.0709 21.7919 17.2326C21.8341 16.4004 21.8402 16.129 21.8402 14.0002C21.8402 11.8713 21.8341 11.6059 21.7919 10.7677C21.7557 9.93542 21.623 9.36249 21.4301 8.86194C21.231 8.34933 20.9597 7.90908 20.5254 7.47486C20.0912 7.04065 19.651 6.76926 19.1384 6.57025C18.6378 6.37726 18.0709 6.24459 17.2326 6.2084C16.4004 6.17222 16.129 6.16016 14.0002 6.16016Z" fill="#43525A"/>
            <path d="M13.9993 9.97754C11.7739 9.97754 9.9707 11.7807 9.9707 14.0061C9.9707 16.2314 11.7739 18.0346 13.9993 18.0346C16.2246 18.0346 18.0278 16.2314 18.0278 14.0061C18.0278 11.7807 16.2246 9.97754 13.9993 9.97754ZM13.9993 16.6174C12.5579 16.6174 11.3879 15.4474 11.3879 14.0061C11.3879 12.5647 12.5579 11.3948 13.9993 11.3948C15.4406 11.3948 16.6106 12.5647 16.6106 14.0061C16.6166 15.4474 15.4466 16.6174 13.9993 16.6174Z" fill="#43525A"/>
            <path d="M19.1257 9.81482C19.1257 10.3335 18.7036 10.7556 18.1849 10.7556C17.6663 10.7556 17.2441 10.3335 17.2441 9.81482C17.2441 9.29618 17.6663 8.87402 18.1849 8.87402C18.7036 8.87402 19.1257 9.29618 19.1257 9.81482Z" fill="#43525A"/>
          </svg>
        </a>
        <a href={get(webinstance, "globalSettings.youtube_link", "#")} title={`Youtube`} target={`_blank`}>
          <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M22.1591 9.87325C21.9634 9.13513 21.3874 8.55359 20.6549 8.35787C19.3297 8 14.0007 8 14.0007 8C14.0007 8 8.6717 8 7.34644 8.35787C6.61392 8.55359 6.03796 9.13513 5.84225 9.87325C5.48438 11.2097 5.48438 14 5.48438 14C5.48438 14 5.48438 16.7903 5.84225 18.1267C6.03796 18.8649 6.61392 19.4464 7.34644 19.6421C8.67729 20 14.0007 20 14.0007 20C14.0007 20 19.3297 20 20.6549 19.6421C21.3874 19.4464 21.9634 18.8649 22.1591 18.1267C22.517 16.7903 22.517 14 22.517 14C22.517 14 22.517 11.2097 22.1591 9.87325Z" fill="#43525A"/>
            <path d="M12.2617 16.533V11.4668L16.7128 13.9999L12.2617 16.533Z" fill="white"/>
          </svg>
        </a>
      </div>

      <div className={styles.mainBar}>
        <div className={`container`}>
          <div className={styles.row}>
            <address>
              <h2><strong>{t("Turistické Informačné Centrum - Región Trnava")}</strong></h2>
              <div>{get(webinstance, "globalSettings.street_and_number", "")}</div>
              <a href={`mailto:${webinstance?.adminEmail}`}>
                {webinstance?.adminEmail}
              </a>
              <a href={`tel:${get(webinstance, "globalSettings.phone", "#")}`}>
                {t("Tel")}.: {get(webinstance, "globalSettings.phone", "-")}
              </a>
            </address>
            <div className={styles.links}>
              <h2><strong>{t("Trnava Tourism")}</strong> - {t("Oblastná organizácia cestovného ruchu")}</h2>
              <ul>
                {map(
                  statics,
                  (item, index) => {
                    return (
                      <li
                        key={`footer-static-page-${item?.id}-${index}`}
                      >
                        <Link
                          href="/stranka/[id]"
                          as={`/stranka/${get(item, "urlTitle")}`}
                        >
                          <a>
                            {get(item, "title")}
                          </a>
                        </Link>
                      </li>
                    );
                  }
                )}
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div className={styles.supporters}>
          <div className={styles.content + " container"}>
            <a href="/" className={styles.logo}>
              <img src={getAttachmentUrl({"fileUrl" : "/files/attachment/2020-09/232/5fa0a5/logo-region-trnava.png" })} title={"Logo región trnava"} />
            </a>
            <div className={styles.support}>
              <span>Realizované s finančnou podporou Ministerstva dopravy Slovenskej republiky.</span>
              <a href="https://www.mindop.sk" target="_blank">
                {/*<img src={getAttachmentUrl({"fileUrl" : "/files/attachment/2020-09/229/3ce4ae/logo-ministerstvo-dopravy-a-vystavby-sr.png" })} title={"Logo ministerstvo dopravy a výstavby slovenskej republiky"} />*/}
                <Image src="/images/footer/mi_dopravy_sr.png" alt={"Ministerstvo"} width={132} height={40} title={"Logo ministerstvo dopravy a výstavby slovenskej republiky"} />
              </a>
              <a href="https://www.slovakia.travel" target="_blank">
                <img src={getAttachmentUrl({"fileUrl" : "/files/attachment/2020-09/235/d0a9c8/logo-slovakia-travel.png" })} title={"Logo slovakia travel"} />
              </a>
            </div>
            <div className={styles.copyright}>
              © {new Date().getFullYear()} {t("Trnava Tourism")} <br/>
              {t("All rights reserved")}
            </div>
          </div>
      </div>
      
      <div className={styles.creator}>
        {t("prevádzkované eshop systémom")}{" "}
        <a href="https://www.grandus.sk" rel="nofollow sponsored">
          Grandus
        </a>{" "}
        {t("od spoločnosti")}{" "}
        <a href="https://www.forbestclients.com" rel="nofollow sponsored">
          For Best Clients, s.r.o.
        </a>
      </div>
      
    </footer>
  );
};

export default Footer;
